import { useState, useLayoutEffect, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Navbar from "../components/dashboard/Navbar";

import storage from "../services/storage";
import classIcon from "../assets/images/classs-img.png";
import Sidebar from "../components/dashboard/Sidebar";
import { useDispatch } from "react-redux";
import { SelectWithRadio } from "../shared/SelectWithRadio";
import { CustomOptions } from "../shared/CustomOptions";
import { booksList, getBooksListing, getClasses } from "../Store/api/classApi";
import { CardSkeleton } from "../shared/CardSkeleton";
import { DraftBooks } from "./DraftBooks";
import { Pagination } from "../shared/Pagination";

const sortingOptions = [
  {
    id: 1,
    label: "Last edited",
    value: "last_updated",
  },
  {
    id: 2,
    label: "Alphabetical (A-Z)",
    value: "ascending",
  },
  {
    id: 3,
    label: "Alphabetical (Z-A)",
    value: "descending",
  },
  {
    id: 4,
    label: "Published",
    value: "published",
  },
  {
    id: 5,
    label: "Private",
    value: "private",
  },
];

const BookShelf = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const Storeuser = storage.get("user");
  const [books, setBooks] = useState([]);
  const [classes, setClasses] = useState([]);
  const [bookList, setBooksList] = useState([]); // useState for replaced books listing API
  const [loader, setLoader] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [pages, setTotalPages] = useState(1);
  const [totalBooks, setTotalBooks] = useState("");
  let storedBookId = localStorage.getItem("lastBookId");
  const [filters, setFilters] = useState({
    sort_by: "",
    class_id: "",
  });

  useLayoutEffect(() => {
    if (Storeuser.status === "denied")
      navigate("/access-denied", { replace: true });
  }, [Storeuser.status]);

  useLayoutEffect(() => {
    dispatch(
      getClasses({
        onSuccess: (res) => {
          const { data = [] } = res;
          setClasses(
            data.map((item) => ({ label: item.courseNumber, value: item._id }))
          );
        },
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setLoader(true);
    dispatch(
      getBooksListing({
        page,
        ...filters,
        onSuccess: (res) => {
          const {
            data = [],
            pagination: { totalBooks = 0, totalPages = 1, currentPage = 1 },
          } = res;
          setLoader(false);
          setBooks(data);
          setPage(currentPage);
          setTotalPages(totalPages);
          setTotalBooks(totalBooks);
        },
      })
    );
  }, [filters, refetch, dispatch, page]);
  
  useEffect(() => {
    dispatch(booksList({
      onSuccess: (res) => {
        const { data = [] } = res;
        setBooksList(data);
      }
    }));
  }, []);

  const handleFilterChange = (item, type) => {
    if (type === "sorting") setFilters({ ...filters, sort_by: item.value });
    else setFilters({ ...filters, class_id: item.value });
  };

  const onPrev = () => setPage((prev) => prev - 1);
  const onPrevFirst = () => setPage(1);
  const onNext = () => setPage((prev) => prev + 1);
  const onNextLast = () => setPage(pages);

  return (
    <div className="wrapper">
      <Sidebar userType="teacher" sideBarEvent="bookshelf" />
      <div id="content">
        <div className="content_dashborad_inner h-100">
          <Navbar sideBarEvent="bookshelf" />

          <div className="main_section_content h-100">
            <div
              className="d-flex flex-column w-100"
              style={{ marginRight: "5px", paddingTop: "8px", rowGap: "20px" }}
            >
              <DraftBooks />
              <div className="d-flex justify-content-between">
                <div className="d-flex" style={{ gap: "30px" }}>
                  <SelectWithRadio
                    placeholder="Sort By"
                    data={sortingOptions}
                    handleFilterChange={handleFilterChange}
                    type="sorting"
                    className="w-220"
                  />
                  <SelectWithRadio
                    placeholder="Class Select"
                    data={classes}
                    handleFilterChange={handleFilterChange}
                  />
                </div>
                <div className="d-flex align-items-center gap-4">
                  <div className="d-flex align-items-center gap-2">
                    <b>{totalBooks}</b>{" "}
                    <span className="book_shelf_listing_count">BOOKS</span>
                  </div>
                  <Pagination
                    {...{
                      page,
                      onNext,
                      onPrev,
                      onPrevFirst,
                      onNextLast,
                      totalPages: pages,
                    }}
                  />
                </div>
              </div>
              <div className="d-flex flex-column">
                {!books.length && !loader && (
                  <div className="d-flex justify-content-center align-items-center w-100 book_shelf_empty_state">
                    <p className="w-45">
                      Looks like your shelf is empty, add private or published
                      books by writing or uploading in greyled
                      <span
                        className="book_shelf_empty_state_text cursor"
                        onClick={() =>
                          navigate(`/create/${storedBookId}?openModel=true`)
                        }
                      >
                        {" "}
                        create
                      </span>
                    </p>
                  </div>
                )}
                {books.length > 0 && !loader && (
                  <div
                    className={`d-flex flex-wrap w-100 overflow-scroll pb-1 ${
                      books.length > 4 ? "h-dv-57" : ""
                    }`}
                    style={{ columnGap: "40px", rowGap: "30px" }}
                  >
                    {books.map((item, index) => (
                      <div
                        key={index}
                        className="book_shelf_list_container h-fit"
                      >
                        <img
                          className="book_shelf_list_class_icon border-0"
                          src={item.coverImage || item?.bookDetailCoverUrl || classIcon}
                          alt="class pic"
                          width={130}
                          height={165}
                        />
                        <div className="book_shelf_list_content_container">
                          <div className="d-flex justify-content-between w-100">
                            <h4
                              className={`book_shelf_list_content_title ${
                                item.bookStatus === "published"
                                  ? "book_shelf_list_title_colors_1"
                                  : "book_shelf_list_title_colors_2"
                              }`}
                            >
                              {item.bookStatus.toUpperCase()}
                            </h4>
                            <div
                              className="d-flex justify-content-between align-items-center"
                              style={{ gap: "20px" }}
                            >
                              <span className="book_edited_last_date">
                                Last edited{" "}
                                {format(
                                  new Date(item.updatedAt),
                                  "MM/dd/yy hh:mma"
                                ).toLowerCase()}
                              </span>
                              <CustomOptions
                                {...item}
                                books={bookList.filter(book => book._id !== item.bookId)}
                                setRefetch={setRefetch}
                              />
                            </div>
                          </div>
                          <div className="d-flex flex-column">
                            <h4 className="book_shelf_list_content_container_title">
                              {item?.title?.length > 45
                                ? `${item.title.slice(0, 45)} ...`
                                : item?.title}
                            </h4>
                            <p className="book_shelf_list_content_detail">{`${item.bookAuthors
                              .map(
                                (book) => `${book.firstName} ${book.lastName}`
                              )
                              .join(", ")} ${
                              item.bookAuthors.length > 2 ? ", +4 authors" : ""
                            }`}</p>
                            <p className="book_shelf_list_content_detail"></p>{" "}
                            {/* Remixed by Author name */}
                            <p className="book_shelf_content_classes">
                              {item.classesArray.length
                                ? `${item.classesArray[0].courseName} ${item.classesArray.length > 1 ? `| ${item.classesArray?.[1]?.courseName}`: ""} | ${item.totalactivities} activities`
                                : `No Classes | 0 activities`}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between w-100">
                            <div className="d-flex" style={{ gap: "8px" }}>
                              {/* <img src="assets/images/alert-circle.svg" alt="alert icon here" />
                              <span className="book_shelf_content_classes align-content-center m-0">updates</span> */}
                            </div>
                            <button
                              className="cursor save-btn fs-14 rounded-0 text-uppercase"
                              onClick={() =>
                                navigate(
                                  `/dashboard/bookshelf/overview/${item.bookId}`
                                )
                              }
                            >
                              Overview --&gt;
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {loader && (
                  <div
                    className={`d-flex flex-wrap w-100 overflow-scroll pb-1 h-dv-52`}
                    style={{ columnGap: "40px", rowGap: "10px", }}
                  >
                    {[...new Array(4)].map((item) => (
                      <CardSkeleton
                        key={item}
                        className="book_shelf_list_container"
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookShelf;
